import classNames from 'classnames';
import type { ReactNode } from 'react';
import { Flex } from '../Flex';
import type { FlexProps, FullWidthProps, SharedComponentProps } from '../types.js';
import * as styles from './index.css';

export type SectionProps = SharedComponentProps<'div'> &
    FullWidthProps &
    FlexProps & {
        pt?: styles.PaddingSize;
        pb?: styles.PaddingSize;
    };

export function Section({ pt = '6', pb = '8', flex, fullWidth, className, children }: SectionProps) {
    return (
        <section
            className={classNames(
                styles.section,
                styles.paddingTopVariants[pt],
                styles.paddingBottomVariants[pb],
                flex && styles.flexVariants[flex === true ? '1' : flex],
                {
                    [styles.fullWidth]: fullWidth,
                },
                className
            )}
        >
            {children}
        </section>
    );
}

export type SectionHeaderProps = {
    /** Usually a string; accepts a `ReactNode` so a skeleton can stand in for a title sourced from loaded data. */
    title: ReactNode;
    extras?: ReactNode;
    description?: ReactNode;
};

export function SectionHeader({ title, extras, description }: SectionHeaderProps) {
    return (
        <Flex direction="column" gap="1" as="header" className={styles.header}>
            {extras ? (
                <Flex as="div" className={styles.title} gap="3" align="center">
                    <h2>{title}</h2>
                    <div className={styles.extras}>{extras}</div>
                </Flex>
            ) : (
                <h2 className={styles.title}>{title}</h2>
            )}
            {description && <p className={styles.description}>{description}</p>}
        </Flex>
    );
}
